module.exports = __webpack_public_path__ + "img/extension_news_bg.e50779e.jpg";